import { User } from '@/types/api/user';
import { authenticatedClient, unauthenticatedClient } from '@/utils/shared/axios';
import { handleApiError } from '@/utils/shared/handle-api-error';

export default {
  get: async (userId: string) => {
    const response = await authenticatedClient.get<User>(`/users/${userId}`, {
      params: {/* fields: 'firstName,lastName'  */},
    });
    return response.data;
  },

  getByEmail: async (email: string) => {
    try {
      const response = await authenticatedClient.get<User>(`/users/email/${email}`);
      return response.data;
    } catch (error: any) {
      throw handleApiError(error);
    }
  },

  current: async () => {
    const response = await authenticatedClient.get<User>(`/users/me`);
    return response.data;
  },

  updateCurrent: async (data: Partial<User>) => {
    const response = await authenticatedClient.patch<void>(`/users/me`, data);
    return response.data;
  },

  create: async (data: Omit<Required<User>, 'id'>) => {
    const response = await unauthenticatedClient.post<{ authenticationId: string; id: string }>(
      `/users/register`,
      data,
    );
    return response.data;
  },

  getBatch: async (userIds: string[]): Promise<User[]> => {
    const response = await authenticatedClient.get<User[]>(`/users/batch`, {
      params: { /* fields: 'firstName,lastName'  */ id: userIds.join(',') },
    });
    return response.data;
  },
};
